import React from 'react';
import Page from '../components/Page';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Table,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import {
  MdEdit,
  MdFormatListBulleted,
  MdFlag,
  MdLanguage,
  MdHome,
  MdAdd,
  MdCameraAlt,
  MdDone,
  MdClear,
  MdFilterList,
  MdCreate,
} from 'react-icons/md';
import { Redirect } from 'react-router';
import StorageService from '../services/StorageService';
import axios from 'axios';
import DataFieldForm from '../components/DataFieldForm';
import OrganisationForm from '../components/OrganisationForm';
import Avatar from '../components/Avatar';
import userImage from '../assets/img/users/profile.jpg';
import companyImage from '../assets/img/users/placeholder.jpg';
import UploadPhotoForm from '../components/UploadPhotoForm';

class UserCompanyPage extends React.Component {
  constructor(props) {
    super(props);

    // this.toggle = this.toggle.bind(this);
    this.state = {
      redirect: false,
      selectedCompanyId: '',
      CompanyName: '',
      CompanyAddress: '',
      CompanyContact: '',
      modal: false,
      compModal: false,
      isEdit: false,
      filterKey: '',
      personTypeList: [],
      dataFieldList: [],
      fieldId: '',
      imagePreviewUrl: '',
      CompanyLogo: '',
      isUpload: false,
      isCompanyLogo: true,
      photoModal: false,
    };
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });

    this.getPersonDataField(event.target.value);
  };

  togglePhotoModal = e => () => {
    return this.setState({
      photoModal: !this.state.photoModal,
    });
  };

  toggle = (action, id) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit:
        id != undefined || (id != null && action == 'EDIT') ? true : false,
      fieldId: id != undefined || (id != null && action == 'EDIT') ? id : '',
    });
  };

  toggleCompModal = (action, id) => () => {
    return this.setState({
      compModal: !this.state.compModal,
      isEdit:
        id != undefined || (id != null && action == 'EDIT') ? true : false,
      selectedCompanyId:
        id != undefined || (id != null && action == 'EDIT') ? id : '',
    });
  };

  get resetState() {
    const comp = StorageService.getSession('selected_org');
    return {
      CompanyLogo: comp.CompanyLogo ? comp.CompanyLogo : '',
      imagePreviewUrl: comp.CompanyLogo ? comp.CompanyLogo : '',
      isUpload: false,
    };
  }

  handleImageChange = event => {
    let reader = new FileReader();
    let file = event.target.files[0];

    reader.onloadend = () => {
      this.setState({
        CompanyLogo: reader.result,
        imagePreviewUrl: reader.result,
        isUpload: !this.state.isUpload,
      });
    };

    reader.readAsDataURL(file);
  };

  discard = () => {
    const comp = StorageService.getSession('selected_org');
    this.setState({
      CompanyLogo: comp.CompanyLogo ? comp.CompanyLogo : '',
      imagePreviewUrl: comp.CompanyLogo ? comp.CompanyLogo : '',
      isUpload: !this.state.isUpload,
    });
  };

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    });

    this.setState({
      modal: false,
      compModal: false,
      photoModal: false,
    });

    if (reload) {
      window.location.reload();
    } else {
      this.getPersonDataField(this.state.filterKey);
    }
  };

  delete = id => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      session_key: user.session_key,
      FieldID: id,
    };

    axios
      .post(url + ':3000/v1/person/deleteDataField', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          });
          return;
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Data field removed successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        });

        this.getPersonDataField(this.state.filterKey);
      })
      .catch(error => {
        alert(error);
      });
  };

  getPersonTypeList = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      session_key: user.session_key,
    };

    axios
      .post(url + ':3000/v1/dropdownlist/personType', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({ personTypeList: result.data });
        if (result.data.length > 0) {
          this.setState({
            filterKey: result.data[0].name,
          });
          this.getPersonDataField(result.data[0].name);
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  getPersonDataField = key => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const comp = StorageService.getSession('selected_org');

    const data = {
      session_key: user.session_key,
      CompanyID: comp.CompanyID,
      PersonType: key,
    };

    axios
      .post(url + ':3000/v1/person/getDataField', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({ dataFieldList: result.data });
      })
      .catch(error => {
        alert(error);
      });
  };

  getCompanyDetails = () => {
    const comp = StorageService.getSession('selected_org');

    this.setState({
      selectedCompanyId: comp.CompanyID,
      CompanyName: comp.CompanyName,
      CompanyAddress: comp.CompanyAddress,
      CompanyContact: comp.CompanyContact,
      CompanyLogo: comp.CompanyLogo,
      imagePreviewUrl: comp.CompanyLogo,
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const selected_org = StorageService.getSession('selected_org');

    const data = {
      session_key: user.session_key,
      CompanyID: this.state.selectedCompanyId,
      Logo: this.state.CompanyLogo,
    };

    axios
      .post(url + ':3000/v1/company/updatePhoto', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        if (this.state.selectedCompanyId === selected_org.CompanyID) {
          selected_org.CompanyLogo = result.data.CompanyLogo;
          StorageService.setSession('selected_org', selected_org);
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Company logo updated successfully',
          level: 'success',
          position: 'br',
          autoDismiss: 2,
          dismissible: 'click',
        });
        window.location.reload();
      })
      .catch(error => {
        alert(error);
      });
  };

  componentDidMount() {
    if (StorageService.getSession('selected_org') === null) {
      this.setState({
        redirect: true,
      });
    } else {
      this.getPersonTypeList();
      this.getCompanyDetails();
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }

    return (
      <Page
        className="UserCompanyPage"
        title="Company Profile"
        breadcrumbs={[{ name: 'Company Profile', active: true }]}
      >
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        <Row>
          <Col lg={3} md={12}>
            <Card className="ps-card-display" style={{ height: '100%' }}>
              <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">
                Company Logo
              </CardHeader>
              <CardBody>
                <Form onSubmit={this.handleSubmit}>
                  <div className="mb-3 text-center">
                    <Avatar
                      className="mx-auto profile-img"
                      src={
                        this.state.imagePreviewUrl === null ||
                        this.state.imagePreviewUrl === ''
                          ? companyImage
                          : this.state.imagePreviewUrl
                      }
                    />
                  </div>
                  <div className="text-center">
                    <Button
                      className="theme-button theme-button-primary d-block mx-auto"
                      onClick={this.togglePhotoModal()}
                    >
                      <MdCameraAlt /> Change
                    </Button>
                    {/* {!this.state.isUpload && (
                      <>
                        <Input
                          type="file"
                          name="file"
                          id="file"
                          className="ps-input-file"
                          onChange={this.handleImageChange}
                        />
                        <Label for="file">
                          <MdCameraAlt /> Upload
                        </Label>
                      </>
                    )} */}

                    {/* {this.state.isUpload && (
                      <>
                        <Button
                          className="theme-button theme-button-primary-light mr-1"
                          onClick={() => this.discard()}
                        >
                          Discard
                        </Button>
                        <Button
                          className="theme-button theme-button-primary"
                          type="submit"
                        >
                          Save Change
                        </Button>
                      </>
                    )} */}
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
          <Col lg={9} md={12}>
            <Card className="ps-card-display" style={{ height: '100%' }}>
              <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">
                Company Information
                <Button
                  className="theme-button theme-button-secondary"
                  onClick={this.toggleCompModal(
                    'EDIT',
                    this.state.selectedCompanyId,
                  )}
                >
                  <MdEdit />
                  Edit
                </Button>
              </CardHeader>
              <CardBody>
                <Row form>
                  <Col lg={4}>
                    <Label>Company Name</Label>
                    <p>{this.state.CompanyName}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Company Contact</Label>
                    <p>{this.state.CompanyContact}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Company Address</Label>
                    <p>{this.state.CompanyAddress}</p>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display main">
              <CardHeader className="d-flex align-items-center justify-content-between">
                Person Data Field
                <Button
                  className="theme-button theme-button-transparent"
                  onClick={this.toggle('ADD', null)}
                >
                  <MdAdd />
                  Create
                </Button>
              </CardHeader>
              <CardBody>
                <Form className="AuthForm mb-4">
                  <Row>
                    <Col md={3}>
                      <div className="d-flex align-items-center">
                        <MdFilterList className="ps-input-icon" />
                        <Input
                          type="select"
                          name="filterKey"
                          value={this.state.filterKey}
                          onChange={this.changeHandler}
                        >
                          {this.state.personTypeList.length > 0 &&
                            this.state.personTypeList.map((item, index) => {
                              return (
                                <option key={index} value={item.name}>
                                  {item.name}
                                </option>
                              );
                            })}
                        </Input>
                      </div>
                    </Col>
                  </Row>
                </Form>

                <Table responsive hover className="ps-table tb-col-5">
                  <thead>
                    <tr>
                      <th>Person Type</th>
                      <th>Field Name</th>
                      <th>Field Type</th>
                      <th>Searchable</th>
                      <th>Search Key Pattern</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.dataFieldList.length < 1 && (
                      <tr>
                        <td colSpan="6">
                          <div className="ps-empty-data">
                            <div className="empty-content">
                              <MdCreate />
                              <h4>No data to show</h4>
                              <span>
                                Click the 'Create' button to add new data field
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}

                    {this.state.dataFieldList.length > 0 &&
                      this.state.dataFieldList.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{item.PersonType}</td>
                            <td>{item.FieldName}</td>
                            <td>{item.FieldType}</td>
                            <td>
                              <span
                                className={
                                  'ps-indicator ' +
                                  (item.Searchable == '1' ? 'on' : 'off')
                                }
                              >
                                {item.Searchable == '1' ? 'Yes' : 'No'}
                              </span>
                            </td>
                            <td>{item.SearchKeyPattern}</td>
                            <td>
                              {item.FieldName !== 'Name' &&
                                item.FieldName !== 'ID' && (
                                  <div className="ps-action-button">
                                    <Button
                                      className="theme-button theme-button-secondary"
                                      onClick={this.toggle(
                                        'EDIT',
                                        item.FieldID,
                                      )}
                                    >
                                      Edit
                                    </Button>
                                    <Button
                                      className="theme-button theme-button-primary-light"
                                      onClick={() => this.delete(item.FieldID)}
                                    >
                                      Delete
                                    </Button>
                                  </div>
                                )}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle()}
          className={this.props.className}
          centered
        >
          <DataFieldForm
            history={this.props.history}
            onToggleModal={this.toggle}
            closeModal={this.closeModal}
            data={this.state}
          />
        </Modal>

        <Modal
          isOpen={this.state.compModal}
          toggle={this.toggleCompModal(null, this.state.selectedCompanyId)}
          className={this.props.className}
          centered
        >
          <OrganisationForm
            history={this.props.history}
            onToggleModal={this.toggleCompModal}
            closeModal={this.closeModal}
            data={this.state}
          />
        </Modal>

        <Modal
          isOpen={this.state.photoModal}
          toggle={this.togglePhotoModal()}
          className={this.props.className}
          centered
        >
          <UploadPhotoForm
            history={this.props.history}
            onToggleModal={this.togglePhotoModal}
            closeModal={this.closeModal}
            data={this.state}
          />
        </Modal>
      </Page>
    );
  }
}
export default UserCompanyPage;
